<script lang="ts">
  import EditableText from './EditableText.svelte';
  import Provenance from './Provenance.svelte';
  import type { BlockBullets, RenderCtx } from './types';

  let { block, ctx, editing = false, onchange }: {
    block: BlockBullets;
    ctx: RenderCtx;
    editing?: boolean;
    onchange?: (next: BlockBullets) => void;
  } = $props();

  function edit(index: number, text: string) {
    onchange?.({ ...block, items: block.items.map((it, i) => (i === index ? { ...it, text } : it)) });
  }
</script>

<ul class="brf-bullets">
  {#each block.items as item, i (i)}
    <li><EditableText value={item.text} {editing} ariaLabel="Bullet {i + 1}"
          onchange={(text) => edit(i, text)} /><Provenance
          provenance={item.provenance} sourceIds={item.source_ids} {ctx} /></li>
  {/each}
</ul>
